import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import AppRouter from './AppRouter.jsx'
import AppErrorBoundary from './components/AppErrorBoundary'
import { AuthProvider } from './contexts/AuthContext'
import { NetworkProvider } from './contexts/NetworkContext'
import { ParcoursImagesProvider } from './contexts/ParcoursImagesContext'
import NetworkStatus from './components/NetworkStatus'
import { captureAppError, captureAppMessage, initMonitoring } from './services/monitoringService'

initMonitoring()

window.addEventListener('error', (event) => {
  captureAppMessage('window.error', {
    message: event?.message || null,
    filename: event?.filename || null,
    lineno: event?.lineno || null,
    colno: event?.colno || null
  })
})

window.addEventListener('unhandledrejection', (event) => {
  const reason = event?.reason
  captureAppError(reason instanceof Error ? reason : new Error(String(reason || 'Unknown rejection')), {
    rejectionName: reason?.name || null
  })
})

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <AppErrorBoundary>
      <NetworkProvider>
        <AuthProvider>
          <ParcoursImagesProvider>
            <NetworkStatus />
            <AppRouter />
          </ParcoursImagesProvider>
        </AuthProvider>
      </NetworkProvider>
    </AppErrorBoundary>
  </StrictMode>,
)
